/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Intro_MoreInputs */



/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Team_Intro_MoreInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_intro_more = /** @type {((inputs?: Team_Intro_MoreInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Intro_MoreInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Meer weten")
	if (locale === "fr") return /** @type {LocalizedString} */ ("En savoir plus")
	return /** @type {LocalizedString} */ ("Learn more")
});